﻿<script>
  export let className;
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="2"
  stroke-linecap="round"
  stroke-linejoin="round"
  class={className}>
  <g transform="matrix(1,0,0,1,0,0)">
    <path
      d="M15.5,10.5v12a1,1,0,0,1-1,1H1.5a1,1,0,0,1-1-1V9.5a1,1,0,0,1,1-1h4"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
    <path
      d="M18.5,3.5H13c-3,0-4,2.792-4,5a7,7,0,0,0,1.5,4V10c0-1,.5-1.5,2.5-1.5h5.5v3l5-5.5L18.5.5Z"
      fill="none"
      stroke-linecap="round"
      stroke-linejoin="round" />
  </g>
</svg>
